import MicroModal from "micromodal";

/* -------------------------------------------------------------------------- */
/*                             Event signup logic                             */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    $("#eventSignup").on("click", function (e) {
      e.preventDefault();
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: {
          action: "nen_process_signup",
          nonce: $("#_wpnonce_signup").val(),
          user_id: $("#event_userid").val(),
          event_id: $("#event_id").val(),
        },
        beforeSend: function () {
          console.log("Signing up...");
        },
        success: function (res) {
          setTimeout(function () {
            $("#signupWrapper").html(res);
            console.log("Successfully signed up!");
          }, 500);
        },
      });
    });

    /* -------------------------------------------------------------------------- */
    /*                           Afmelden voor evenement                          */
    /* -------------------------------------------------------------------------- */
    $("#eventSignoff").on("click", function (e) {
      e.preventDefault();
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "html",
        data: {
          action: "nen_process_signoff",
          nonce: $("#_wpnonce_signoff").val(),
          user_id: $("#event_userid").val(),
          event_id: $("#event_id").val(),
        },
        beforeSend: function () {
          console.log("Signing off...");
        },
        success: function (res) {
          $("#signupWrapper").html(res);
          console.log("Successfully signed off!");
        },
      });
    });

    if (document.getElementById("attendee-modal")) {
      MicroModal.init({
        onShow: (modal) => console.info(`${modal.id} is shown`), // [1]
        onClose: (modal) => console.info(`${modal.id} is hidden`), // [2]
        openTrigger: "data-custom-open", // [3]
        closeTrigger: "data-custom-close", // [4]
        openClass: "is-open", // [5]
        disableScroll: true, // [6]
        disableFocus: false, // [7]
        awaitOpenAnimation: true, // [8]
        awaitCloseAnimation: true, // [9]
        debugMode: true, // [10]
      });

      $("#attendeeModalBtn").on("click", function (e) {
        e.preventDefault();

        MicroModal.show("attendee-modal"); // [1]
        if (!$("#attendee-modal-content").hasClass("content-loaded")) {
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "nen_view_event_attendees",
              nonce: $("#_wpnonce_modal").val(),
              user_id: $("#attendeeModalBtn").data("user-id"),
              event_id: $("#attendeeModalBtn").data("event-id"),
            },
            beforeSend: function () {
              // console.log("Loading members...");
            },
            success: function (res) {
              $("#attendee-modal-content").html(res);
              $("#attendee-modal-content").addClass("content-loaded");
              // console.log("Members should be loaded!");
            },
          });
        }
      });
    }
  });
});
